import { defaultPm2PrintChunkClassName } from '@provider/print';
import { printCtaComponent } from './printer.to-jsx.js';

const printCtaComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: printCtaComponent(node, {
      ...context,
      parentPrinters: {}
    })
  }];
};
const ctaComponentPaperPrinters = {
  "cta-component": printCtaComponentPaper
};

export { ctaComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
